export async function requestCameraAccess(): Promise<MediaStream | null> {
  try {
    // Request access to the camera
    const stream: MediaStream = await navigator.mediaDevices.getUserMedia({ video: true });

    // Create a temporary, hidden video element
    const videoElement: HTMLVideoElement = document.createElement("video");
    videoElement.style.display = "none"; // Hide the video element
    videoElement.srcObject = stream;
    videoElement.autoplay = true;
    videoElement.playsInline = true;

    // Append to the document to initialize stream
    document.body.appendChild(videoElement);

    // Wait briefly to ensure the stream starts (optional, but good practice)
    await new Promise<void>((resolve) => {
      setTimeout(resolve, 100);
    });

    // Clean up: Remove the video element
    videoElement.srcObject = null;
    document.body.removeChild(videoElement);

    return stream; // Return the MediaStream for further use if needed
  } catch (error: unknown) {
    return null; // Indicate failure
  }
}
